
import './App.css';
import ConnectTheDots from './components/connect-the-dots';

function App() {
  return (
    <div className="App">
      <ConnectTheDots/>
    </div>
  );
}

export default App;
